var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Grid, GridColumn, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../../Config';
import { addLanguageSlugToUrl } from '../../util/PathUtil';
import { frontPageGaData } from '../FrontPageBlocks';
import { injectStores } from '../../util/StoresUtil';
let InvoicePaymentButton = class InvoicePaymentButton extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { totalAmountToPay } = this.props;
        const { translate, currentLanguage } = this.translateStore;
        const { hasUnsettledInvoices } = this.invoiceStore;
        if (!hasUnsettledInvoices) {
            return '';
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "small" }),
            React.createElement(Grid, { align: ['between-xs'], horizontalGutter: "none" },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement("h4", { className: "text-bold" }, translate('billing.amount-to-pay'))),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement("h4", { className: "text-bold" },
                        totalAmountToPay,
                        " ",
                        translate('billing.invoice-currency-sign')))),
            React.createElement(Grid, { align: ['end-xs'] },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, { text: translate('billing.pay-button-text'), size: "small", url: addLanguageSlugToUrl(config.billsPayButton, currentLanguage), onClick: () => frontPageGaData('Arved', 'Maksma') })))));
    }
};
InvoicePaymentButton = __decorate([
    injectStores,
    observer
], InvoicePaymentButton);
export default InvoicePaymentButton;
